import { useSearchParams } from 'react-router-dom';
import LegacyConfigContract from './index';
import CardChangeJourneyPage from './journey/CardChangeJourneyPage';

/**
 * `/contract/:contractId` (troca de cartão) — a UI 2026 é o padrão; o legado só abre com `?legacy=true`
 * (mesma convenção da renovação), para rollback rápido durante a transição.
 */
export default function CardChangeRoute() {
  const [searchParams] = useSearchParams();
  return searchParams.get('legacy') === 'true' ? <LegacyConfigContract /> : <CardChangeJourneyPage />;
}
